module.exports = __webpack_public_path__ + "static/img/logo@2x.d695a0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo@2x.png
// module id = RNtg
// module chunks = 121